<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-07-11 13:58:39
 * @LastEditors: sjq
 * @LastEditTime: 2024-06-11 14:30:14
 -->
<template>
  <div class="minheight100" style="padding-bottom: 95px" v-if="detail">
    <app-header v-if="appUser.isNative" title="友邻少年"></app-header>
    <div class="share-activity-submit">
      <div class="prize-main">
        <div class="prize-img prize-img1" v-if="detail.type === 'credit'">
          <div class="card-con">
            <div class="text">
              {{ detail.num }}
            </div>
          </div>
          <div class="zd">
            {{ detail.goodsName }}
          </div>
        </div>
        <!-- 0 90001实物  1 credit积分  2 20001专辑   4 60001礼品卡 5 10010自定义 -->
        <div
          class="prize-img"
          :class="{ 'prize-img2': detail.type === '20001', 'prize-img4': detail.type === '60001' }"
          v-else
        >
          <img v-if="detail.type === '60001'" :src="detail.giftCardImg" alt="" />
          <template v-else-if="detail.type === '90001'">
            <img :src="detail.realGoodsImg" v-if="detail.realGoodsImg" />
            <img src="./images/good_default.png" alt="" v-else />
          </template>
          <img v-else-if="detail.type === '10010'" :src="detail.realGoodsImg" alt="" />
          <img v-else-if="detail.type === '20001'" :src="detail.albumCover" alt="" />
        </div>
        <div class="prize-detail">
          <div class="prize-title">{{ detail.type === 'credit' ? detail.num : '' }} {{ detail.goodsName }}</div>
          <div class="prize-commit" v-if="detail.type === '60001'">
            使用有效期：{{
              detail.termType == 1
                ? detail.useStartDate.split('T')[0].replace(/-/g, '.') +
                  '-' +
                  detail.useEndDate.split('T')[0].replace(/-/g, '.') +
                  '有效'
                : '领取后' + detail.dayUse + '天内有效'
            }}
          </div>
          <div class="prize-commit" v-else-if="detail.type === '20001'">{{ detail.albumDescription }}</div>
          <div class="prize-commit" v-else-if="detail.type === '10010'">{{ detail.goodsDescription }}</div>
          <template v-if="detail.type === '20001'">
            <div class="num">共 {{ detail.courseCount }} 节</div>
            <div class="day">{{ detail.equityDays }} 天内有效</div>
          </template>
        </div>
      </div>
      <div class="address-main" @click="setAddress" v-if="detail.type === '90001'">
        <div class="address-icon">
          <img src="./images/address_icon.png" alt="" />
        </div>
        <div class="address-content" v-if="addressDetail">
          <div class="address-detail">
            <div class="name">
              {{ addressDetail.contactName }}
            </div>
            <div class="contact">
              {{ addressDetail.contactNo }}
            </div>
          </div>
          <div class="address-commit">
            {{ addressDetail.addressArea.split(' / ').join('') }}{{ addressDetail.addressDetail }}
          </div>
        </div>
        <div class="address-content" v-else>
          <div class="div address-content-tip">添加收货地址</div>
        </div>
        <Icon name="arrow" />
      </div>
      <div class="upload-main" v-if="dataDetail.receiveType !== 2">
        <div class="upload-title">
          <div class="title">上传截图</div>
          <div class="tip" @click="show = true">
            <Icon name="warning" />
            查看示例
          </div>
        </div>
        <Upload :imgList="imgList" @upload="upload" :num="3"></Upload>
      </div>
    </div>
    <div class="fixed-bottom">
      <div class="flexdiv average">
        <div class="btn-common block" @click="submit">提交</div>
      </div>
    </div>
    <Popup v-model="show" class="border-popup">
      <div class="title-img">
        <img src="./images/jtsl-title.png" alt="" />
      </div>
      <div class="jtsl-main">
        <div class="list">
          <img src="./images/jtsl-icon1.png" alt="" />
          包含时间和任务栏
        </div>
        <div class="list">
          <img src="./images/jtsl-icon2.png" alt="" />
          分享内容为本次活动海报和文案
        </div>
        <div class="list">
          <img src="./images/jtsl-icon3.png" alt="" />
          海报在朋友圈须保留2小时
        </div>
        <div class="list">
          <img src="./images/jtsl-icon4.png" alt="" />
          不可以分组或设置为私密
        </div>
      </div>
      <div class="jtsl-img">
        <img src="./images/jtsl.png" alt="" />
      </div>
      <div class="btn-common block jtsl-btn" @click="show = false">我知道了</div>
    </Popup>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import 'swiper/dist/css/swiper.css'
import { activityService, addressService } from '@/api'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Popup, Icon } from 'vant'
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'
import Upload from '@/components/upload/index.vue'
const action = 'shareActivitySubmit'

export default {
  name: action,
  components: { Upload, Icon, Popup },
  data() {
    return {
      appUser,
      title: '友邻少年',
      dataDetail: {},
      detail: {},
      addressDetail: {},
      imgList: [],
      show: false,
      activityId: '',
      rewardGoodsId: '',
      submitLoading: false
    }
  },
  mixins: [Body],
  created() {
    this.activityId = this.$route.query.activityId
    this.rewardGoodsId = this.$route.query.rewardGoodsId
    // // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getData(true)
  },
  activated() {
    this.activityId = this.$route.query.activityId
    this.rewardGoodsId = this.$route.query.rewardGoodsId
    if (this.rewardGoodsId !== this.detail.goodsId) {
      this.getData()
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log(to) //当前
    console.log(from)
    next(e => {
      if (from.name === 'shareActivity' || from.name === 'shareActivityResult') {
        e.imgList = []
      }
    })
  },
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  mounted() {},

  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      console.log('进微信登录了')
      console.log(appUser.userId)
      this.shareUserId = appUser.userId
      setTimeout(() => {
        this.getData()
      })
    },
    //详情
    getData(type) {
      activityService
        .shareActivityDetail({
          activityId: this.activityId
        })
        .then(res => {
          this.dataDetail = res.activityInfo
          this.detail = this.dataDetail.rewardGoodsList.find(item => item.goodsId == this.rewardGoodsId)
          if (this.detail.type === '90001') {
            let addressChecked = JSON.parse(localStorage.getItem('addressChecked')) || {}
            this.addressDetail = addressChecked[appUser.userId]
            if (!this.addressDetail) this.getAddressDefault()
          }
          if (this.dataDetail.receiveType !== 2 && type) {
            setTimeout(() => {
              this.show = true
            }, 100)
          }
        })
        .catch(err => {
          this.dataDetail = err.data
        })
    },
    setAddress() {
      this.$router.push({
        name: !this.addressDetail ? 'addressEdit' : 'addressListNew',
        query: {
          type: 'default'
        }
      })
    },

    submit() {
      if (this.dataDetail.receiveType !== 2) {
        if (this.imgList.length === 0) {
          Toast('请上传截图')
          return
        }
        if (this.imgList.filter(item => item.status !== 'done').length > 0) {
          Toast('截图待上传完成')
          return
        }
      }
      if (this.detail.goodsLimitArea && this.detail.goodsLimitArea.length) {
        let index = this.detail.goodsLimitArea.findIndex(item => item.cityCode === this.addressDetail.cityCode)
        console.log(index)
        if (index !== -1) {
          Toast({ message: '该地区暂不支持发货\n请更换地址或重新选择奖品', position: 'center' })

          return
        }
      }
      if (this.submitLoading) return
      this.submitLoading = true
      activityService
        .shareActivitySubmit({
          activityId: this.activityId,
          rewardType: this.dataDetail.rewardType,
          rewardGoodsId: this.detail.goodsId,
          userAddressId: this.detail.type === '90001' ? this.addressDetail.id : null,
          rewardGoodsName: this.detail.goodsName,
          rewardNum: this.detail.num,
          equityDays: this.detail.equityDays,
          evidence: this.imgList.map(item => item.url).join(',')
        })
        .then(res => {
          this.submitLoading = false

          this.$router.replace({
            name: 'shareActivityResult',
            query: {
              activityId: this.activityId
            }
          })
        })
        .catch(() => {
          this.submitLoading = false
        })
    },
    getAddressDefault() {
      addressService.list('default').then(res => {
        this.addressDetail = res
      })
    },
    upload(data) {
      console.log(data, '上传成功')
      this.imgList = data
    },
    // 设置分享数据
    setShareData() {
      if (this.dataDetail && this.dataDetail.shareMainTitle) {
        return {
          title: this.dataDetail.shareMainTitle,
          desc: this.dataDetail.shareSecondTitle,
          link: location.href,
          imgUrl: this.dataDetail.shareImg
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'index.scss';
.minheight100 {
  background: #f5f5f5;
}
.share-activity-submit {
  padding: 16px;
}

.content-border-top {
  margin-top: -34px;
  .line-border {
    height: 34px;
    border-radius: 34px 34px 0 0;
    margin: 0 -10px;
    border: 1px solid #fff;
    background: rgba(255, 255, 255, 0.4);
  }
}
.share-content {
  background: #fff;
  padding-top: 30px;
  border-radius: 24px 24px 0 0;
  margin-top: -24px;
}

.upload-main {
  border-radius: 8px;
  background: #fff;
  padding: 12px;
}

.upload-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  .title {
    font-size: 16px;
  }
  .tip {
    color: #00b25a;

    .van-icon {
      color: #00b25a;
    }
  }
}
.border-popup {
  overflow: inherit;
  .title-img {
    width: 147px;
    margin: 0 auto;
    margin-top: -25px;
  }
  .jtsl-main {
    padding: 0px 35px;
    min-width: 295px;
    .list {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
  .jtsl-img {
    width: 150px;
    margin: 0 auto;
    margin-bottom: 0;
  }
  .jtsl-btn {
    width: 176px;
    margin-bottom: 26px;
  }
}
</style>
